export default __webpack_public_path__ + "static/media/dodo.cf2b4bec.jpeg";